function base64UrlToBuffer(value) {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
  const bytes = atob(padded);
  return Uint8Array.from(bytes, (character) => character.charCodeAt(0)).buffer;
}

function bufferToBase64Url(value) {
  if (!value) return null;
  const bytes = new Uint8Array(value);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/u, '');
}

export function prepareCreationOptions(options) {
  return {
    ...options,
    challenge: base64UrlToBuffer(options.challenge),
    user: { ...options.user, id: base64UrlToBuffer(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map((credential) => ({
      ...credential,
      id: base64UrlToBuffer(credential.id),
    })),
  };
}

export function prepareAssertionOptions(options) {
  return {
    ...options,
    challenge: base64UrlToBuffer(options.challenge),
    allowCredentials: (options.allowCredentials || []).map((credential) => ({
      ...credential,
      id: base64UrlToBuffer(credential.id),
    })),
  };
}

export function serializeCredential(credential) {
  const { response } = credential;
  const serializedResponse = {
    clientDataJSON: bufferToBase64Url(response.clientDataJSON),
  };

  if ('attestationObject' in response) {
    serializedResponse.attestationObject = bufferToBase64Url(response.attestationObject);
    serializedResponse.transports = response.getTransports?.() || [];
  } else {
    serializedResponse.authenticatorData = bufferToBase64Url(response.authenticatorData);
    serializedResponse.signature = bufferToBase64Url(response.signature);
    serializedResponse.userHandle = bufferToBase64Url(response.userHandle);
  }

  return {
    id: credential.id,
    rawId: bufferToBase64Url(credential.rawId),
    type: credential.type,
    response: serializedResponse,
    clientExtensionResults: credential.getClientExtensionResults(),
  };
}

export function ensurePasskeySupport() {
  if (!window.isSecureContext || !window.PublicKeyCredential || !navigator.credentials) {
    throw new Error(
      'کلید عبور فقط در مرورگر پشتیبان و اتصال امن HTTPS یا localhost قابل استفاده است.'
    );
  }
}

export function getPasskeyErrorMessage(error, action = 'استفاده از کلید عبور') {
  if (error?.name === 'NotAllowedError') {
    return `${action} انجام نشد؛ مهلت پنجره امنیتی تمام شده یا درخواست توسط شما، مرورگر یا سیستم‌عامل لغو شده است. دوباره تلاش کنید و پنجره Windows Hello یا کلید امنیتی را تأیید کنید.`;
  }
  if (error?.name === 'SecurityError') {
    return 'دامنه یا نشانی امن کلید عبور با نشانی فعلی سامانه یکسان نیست. سامانه را با localhost یا نشانی HTTPS تنظیم‌شده باز کنید.';
  }
  if (error?.name === 'InvalidStateError') {
    return 'این کلید عبور قبلاً برای حساب ثبت شده یا دیگر قابل استفاده نیست.';
  }
  if (error?.name === 'AbortError') {
    return 'عملیات کلید عبور لغو شد؛ دوباره تلاش کنید.';
  }
  return error?.message || `${action} انجام نشد.`;
}
